import React, { useEffect } from 'react';
import ReviewsTab from '../ActiveTopic/ReviewsTab/ReviewsTab';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPersonalDetails } from '../../store/redux/slices/tenantSettingSlice';
import styled from 'styled-components';
import CollapsibleText from '../../components/ReviewText/collapsibleText';
import { Favorite, ThumbUp, Verified } from '@mui/icons-material';
import { emoji_anger, emoji_disgust, emoji_fear, emoji_joy, emoji_neutral, emoji_sadness, emoji_surprise, EmojiHeartIcon, NegativeSentiment, NeutralSentimenr, PositiveSentiment } from '../../Common/SvgIcon/CommonSvgIcons';
import { formatNumberCompact } from '../../utils/NumberFormatter';
import { reviewsForSingleComment } from '../../store/redux/slices/topicSlice';


const PopupContainer = styled.div`
  width:100%; /* Adjust the width as needed */
  background-color: white;
  border-radius: 0px;
  margin-top:25px;
`;

const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  /* color: white; */
  padding: 18px 9px;
  border-radius: 0px;
`;

const PopupBoderBottom = styled.div`
  width: 96%;
  margin-left: auto;
  margin-right: auto;
  height: 1px;
  background: rgba(217, 217, 217, 1);
`;

const IconSpan = styled.span`
  //display:flex;
  margin: 10px 0px 0px 25px;
  font-family: Inter;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: rgb(99, 99, 99);
`;

const CloseIcon = styled.span`
  //float:right;
  margin-right: 15px;
  display: flex;

  & > svg {
    fill: blue;
    stroke: ${(pop) => (pop.selectedChannel === 'Flipkart' ? 'none' : 'none')};
  }
`;

const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow-y: scroll;
  height: 460px;
  margin-bottom: 20px;
  span {
    display: flex;
    // margin-left: 25px;

    color: #636363;
    // font-family: Open Sans;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
  }
`;

const Wrapper = styled.div`
  // margin: 50px 25px;
  height: 100%;
  /* width: 100%; */
  margin: 10px;
  .header {
    color: #636363;
    // font-family: Montserrat;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;

    & > div:nth-child(2),
    & > div:nth-child(3) {
      color: #636363;
      // font-family: Montserrat;
      font-family: Inter;
      font-size: 18px;
      font-weight: 600;
    }
  }
`;
const RowWrapper = styled.div`
  & > div {
    width: 100%;
    min-height: 120px;
    box-sizing: border-box;
    margin-top: 15px;
    border-radius: 15px;
    border: 1px solid #d9d9d9;
    padding: 20px 0;
    &:hover {
      background: #f0fff0;

      cursor: pointer; /* Change the cursor to indicate interactivity */
      // transform: scale(1.02); /* Slightly scale up the row */
      // transition: all 0.3s ease; /* Smooth transition for all changes */
    }
    &:hover .collapsible-text {
      background-color: rgba(
        242,
        242,
        254,
        1
      ) !important; // Change background to black on hover
      color: white; // Change text color to white to make it visible
    }
  }
`;
const EmotionsWrapper = styled.span`
  display: flex;
  gap: 40px;
  margin-top: 10px;
  margin-left: 15px;
`;
const SentimentWrapper = styled.div`
  display: flex;
  gap: 10px;
  svg {
    width: 19px;
    height: 19px;
  }
`;
const RowData = styled.div`
  display: grid;
  grid-template-columns: 45% 1fr 1fr 1fr;
  gap: 5px;
  text-align: left;
  color: #2a2929;
  // font-family: Open Sans;
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  word-wrap: break-word;

  & .review {
    padding-left: 15px;

    & > div:nth-child(1) {
      color: #2a2929;
      // font-family: Montserrat;
      font-family: Inter;
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 10px;
      width: 100%;
    }
  }

  & > div:nth-child(2),
  & > div:nth-child(3) {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
  }

  & > div:not(:first-child) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .filterColumn {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  & .profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    // font-family: Open Sans;
    font-family: Inter;
    font-size: 15px;
    font-weight: 600;

    & :last-child {
      //   color: #636363;
    }
  }
`;

const SpanEmoji = styled.span`
  // border: 1px solid;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding: 3px;
  background: ${(props) => (props.color ? props.color : '#4080ff')};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  color: white !important;
  margin-left: 2px;
  margin-right: 2px;
`;
const SearchWrapper = styled.div`
  // display: flex;
  // margin-left: -40px;
  // margin-bottom: ;
  // margin-bottom: ${(props) =>
    props.selectedChannel === 'Amazon' ? '105px' : '0px'};

  display: grid;
  grid-template-columns: 70% 14% 170px;
  gap: 25px;
  margin-top: 20px;

  .flexWrap {
    display: flex;
    margin-left: -50px;
  }
  span {
    // position: relative;
    // left: 50px;
    // top: 45%;
    position: relative;
    left: 60px;
    // /* top: 35%; */
    height: 48px;
    display: flex;
    justify-content: initial;
    align-items: center;
    // margin-top: 10px;
  }
`;

const Button = styled.button`
  cursor: pointer;
  width: ${(props) => (props.topic ? '135px' : '170px')};
  height: 50px;
  padding: 7px 21px;
  justify-content: center;
  align-items: center;
  // margin: 0px 0px 0px 20px;
  color: white;

  outline: none; /* Remove default outline */
  // font-family: Open Sans;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
  border-radius: 25px;
  // border-radius: 100px;
  background: ${({ backcolor }) => backcolor || '#353cf7'};
  border: none;
`;

const Input = styled.input`
  margin: 0px 0px 0px 30px;
  padding-left: 40px;
  width: 100%;
  height: 45px;
  border-radius: 15px;
  border: 1px solid #a2a2a2;

  color: #000;
  // font-family: Montserrat;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  outline: none; /* Remove default outline */
  font-weight: 500;
  &:focus {
    border: 1px solid #a2a2a2;
    outline: none; /* Remove default outline */
  }
`;

const Line = styled.div`
  margin-top: 25px;
  margin-bottom: 5px;
  height: 1px;
  width: 100%;
  background: #dddddd;
`;


const PostTab = () => {
    const [searchParams] = useSearchParams();

    const uuid = searchParams.get("uuid");
    const job = searchParams.get("job");
    const id = searchParams.get("id");
    const channel = searchParams.get("channel");
    let columns= channel == 'facebook'
            ? ['Comment', 'Profile', 'Reactions', 'Replies']
            : ['Comment', 'Profile', 'Likes', 'Replies']
        
    const is_comment = searchParams.get("is_comment");
    const { personalDetailsData } = useSelector((state) => state.tenantSetting) || {};
    const dispatch = useDispatch();
      const { reviewsForTopicData, searchVal, searchText } =
        useSelector((state) => state.topicBuilder) || null;
    
    let topic = channel == 'flipkart' ? false : true
    console.log(is_comment,"is_comment");
    const formatValue = 'dd/MM/yyyy';
    // personalDetailsData?.app_preference?.date_format === 'dd/mm/yyyy'
    //   ? 'dd/MM/yyyy'
    //   : personalDetailsData?.app_preference?.date_format === 'mm/dd/yyyy'
    //   ? 'MM/dd/yyyy'
    //   : personalDetailsData?.app_preference?.date_format === 'yyyy/mm/dd'
    //   ? 'yyyy/MM/dd'
    //   : 'dd/MM/yyyy';
    useEffect(() => {
        if (personalDetailsData === null) {
            dispatch(getPersonalDetails());
        }
        if(is_comment == '1'){
            //   console.log("============val================", apiVal?.[0]);
              dispatch(reviewsForSingleComment( {
                        tenant_id: (uuid),
                        job_id: Number(job),
                        post_id: id
                    }));
            //   setLoading(false);
        
        }
        const timer = setTimeout(() => {
            sessionStorage.removeItem('post_login_redirect');
            console.log('Session storage cleared');
        }, 30000); // 30 seconds

        return () => clearTimeout(timer); // cleanup
    }, []);


    
  const getWeekValue = (val) => {
    const currentDate = new Date();
    const givenDate = new Date(val);

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - givenDate;

    // Convert milliseconds to days
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    // console.log(diffInDays,'diffInDays');

    // Convert days to weeks
    // const diffInWeeks = diffInDays / 7;
    const diffInWeeks = Math.round(diffInDays / 7);
    const diffInHours = diffInMs / (1000 * 60 * 60);

    // Set the difference in weeks
    // setWeekDiff(diffInWeeks);
    if (diffInDays < 1) {
      // If less than a day, return hours
      return Math.round(diffInHours) <= 1
        ? `${Math.round(diffInHours)} hr ago`
        : `${Math.round(diffInHours)} hrs ago`;
    } else if (diffInDays < 7) {
      return Math.round(diffInDays) == 1
        ? `${Math.round(diffInDays)} day ago`
        : `${Math.round(diffInDays)} days ago`;
    } else {
      return `${diffInWeeks} w`;
    }
    // return diffInWeeks
  };


    return (
        <div style={{

            width: '90%',
            marginLeft: 'auto',
            marginRight: 'auto'
        }}>
          {
            is_comment == '1'  ?
            
            
                  <PopupContainer topic={topic} popupwidth={'100%'}>
                    
                    {/* <PopupBoderBottom></PopupBoderBottom> */}
                    <PopupBody>
                      <Wrapper>
                        <RowData className='header'>
                          {columns.map((column, i) => {
                            // if (filterCol.includes(i + 1)) {
                            return (
                              <div
                                className='filterColumn'
                                key={i}
                                // onClick={() => handleFilter(i)}
                              >
                                {column}&nbsp;
                                {/* {sort_icon} */}
                              </div>
                            );
                            // }
            
                            // return <div key={i} style={{ paddingLeft: '15px' }}>{column}</div>;
                          })}
                        </RowData>
                        <RowWrapper>
                          {reviewsForTopicData?.length > 0 &&
                            reviewsForTopicData?.map((message, index) => (
                              <RowData key={index}>
                                <div className='review'>
                                  <div>
                                    {/* Post on{' '} */}
                                    {/* {formatDate(
                                channel === 'twitter'
                                  ? message.date
                                  : message.date || message['Reviewed on']
                              )} */}
                                  </div>
                                  <div>
                                    <div style={{ minHeight: '60px' }}>
                                      <CollapsibleText
                                        text={
                                          //   channel === 'twitter'
                                          message.comment || message.text
                                          // : message.posts || message.review_meta || message?.text
                                        }
                                        link={message?.post_url || ''}
                                      />
                                    </div>
            
                                    <div style={{ marginBottom: '-10px' }}>
                                      {/* {message.time} */}
                                      {getWeekValue(message.time || message.created_at)}
                                    </div>
                                  </div>
                                </div>
                                {/* columns.includes('Profile') && */}
                                {
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div
                                      title={
                                        message?.gender === 'male'
                                          ? 'Male'
                                          : message?.gender === 'female'
                                          ? 'Female'
                                          : ''
                                      }
                                      style={{ marginRight: '5px' }}
                                    >
                                      {message?.gender === 'male' ? (
                                        <img
                                          width={24}
                                          src={require('../../assests/images/gendermale.png')}
                                        />
                                      ) : message?.gender === 'female' ? (
                                        <img
                                          width={24}
                                          src={require('../../assests/images/genderfemale.png')}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <div className='profile'>
                                      <span>
                                        {message.user_name}
                                        {message?.verified && (
                                          <span
                                            className='verified'
                                            style={{
                                              color: 'rgb(25, 118, 210)',
                                              height: '23px',
                                              marginLeft: '8px',
                                            }}
                                          >
                                            <Verified
                                              style={{ color: 'rgb(25, 118, 210)' }}
                                            />
                                          </span>
                                        )}
                                      </span>
            
                                      {/* {channel === 'instagram' && (
                                <span style={{ fontSize: '12px' }}>
                                  {formatNumberVal(message['followers_count'] || 0)}
                                </span>
                              )} */}
                                    </div>
                                  </div>
                                }
                                <div className='helpful'>
                                  {channel == 'facebook'
                                    ? ''
                                    : formatNumberCompact(
                                        message?.likes_count || message?.likes
                                      ) || 0}
                                  {channel == 'facebook' ? (
                                    <span
                                      style={{
                                        marginLeft: '5px',
                                        color: 'rgba(222, 13, 13, 1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <SpanEmoji color='#4080ff'>
                                        <ThumbUp
                                          style={{
                                            height: '100%',
                                            width: '90%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '12px',
                                          }}
                                        />
                                      </SpanEmoji>
                                      <SpanEmoji color='#ed5168'>
                                        <Favorite
                                          style={{
                                            height: '100%',
                                            width: '90%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '12px',
                                          }}
                                        />
                                      </SpanEmoji>
                                      <span
                                        style={{ marginLeft: '2px', marginRight: '4px' }}
                                      >
                                        {EmojiHeartIcon}
                                      </span>
                                      <span>
                                        {formatNumberCompact(
                                          message?.likes_count || message?.likes
                                        ) || 0}{' '}
                                      </span>
                                    </span>
                                  ) :
                                    channel == 'youtube' ?
                                      <SpanEmoji color='black'>
                                        <ThumbUp
                                          style={{
                                            height: '100%',
                                            width: '90%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '12px',
                                          }}
                                        />
                                      </SpanEmoji>
                                      :
                                      (
                                        <span
                                          style={{
                                            marginLeft: '5px',
                                            color: 'rgba(222, 13, 13, 1)',
                                          }}
                                        >
                                          <Favorite />
                                        </span>
                                      )}
                                </div>
                                <div>
                                  {formatNumberCompact(
                                    message?.replies || message?.replies_count
                                  ) || 0}
                                </div>
                                <EmotionsWrapper>
                                  <SentimentWrapper
                                    title={
                                      message?.sentiment === 1
                                        ? 'Positive'
                                        : message?.sentiment === -1
                                        ? 'Negative'
                                        : 'Neutral'
                                    }
                                  >
                                    Sentiment:{' '}
                                    {message?.sentiment === 1
                                      ? PositiveSentiment
                                      : message?.sentiment === -1
                                      ? NegativeSentiment
                                      : NeutralSentimenr}
                                  </SentimentWrapper>
            
                                  {message?.emotion?.length > 0 && (
                                    <SentimentWrapper
                                      title={
                                        message?.emotion === 'neutral'
                                          ? 'Neutral'
                                          : message?.emotion === 'surprise'
                                          ? 'Surprise'
                                          : message?.emotion === 'joy'
                                          ? 'Joy'
                                          : message?.emotion === 'fear'
                                          ? 'Fear'
                                          : message?.emotion === 'sadness'
                                          ? 'Sadness'
                                          : message?.emotion === 'anger'
                                          ? 'Anger'
                                          : 'Disgust'
                                      }
                                    >
                                      Emotion:
                                      {message?.emotion === 'neutral'
                                        ? emoji_neutral
                                        : message?.emotion === 'surprise'
                                        ? emoji_surprise
                                        : message?.emotion === 'joy'
                                        ? emoji_joy
                                        : message?.emotion === 'fear'
                                        ? emoji_fear
                                        : message?.emotion === 'sadness'
                                        ? emoji_sadness
                                        : message?.emotion === 'anger'
                                        ? emoji_anger
                                        : emoji_disgust}
                                    </SentimentWrapper>
                                  )}
                                </EmotionsWrapper>
                              </RowData>
                            ))}
                        </RowWrapper>
                        {/* <Pagination
                          currentPage={currentPage}
                          totalCount={reviewsForTopicData?.length || 0}
                          pageSize={PageSize}
                          onPageChange={(page) => setCurrentPage(page)}
                          reviewsData={reviewsForTopicData}
                        /> */}
                      </Wrapper>
                    </PopupBody>
                  </PopupContainer>
                  :
                  <ReviewsTab
                resetFlag={false}
                min={''}
                max={''}
                startDate={''}
                search_type={''}
                endDate={''}
                preview_uuid={''}
                job_id={70}
                filteredReviews={null}
                channel={channel}
                formatValue={formatValue}
                is_single_post={true}
                is_comment={is_comment}
                apiVal={[
                    {
                        tenant_id: (uuid),
                        job_id: Number(job),
                        post_id: id
                    }
                ]}
            /> 

          }

        </div>
    );
};


export default PostTab;